// Used in selected-assignables.effect.ts

import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "warning-dialog",
    templateUrl: "./warning-dialog.component.html",
    styleUrls: ["./warning-dialog.component.scss"],
    standalone: false
})
export class WarningDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<WarningDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    close(): void {
        this.dialogRef.close(1);
    }
}
